import DialogPopupAbstract from "components/DialogPopupAbstract";

import Button from "components/Button";

import { ReactComponent as CloseIcon } from 'icons/close.svg';

import './index.less';
import './themes/default.less';

export default class Dialog extends DialogPopupAbstract {
    constructor(props) {
        super(props);

        this.state = {
            opened: false,
            disableSave: false,
        };

        this.hideBackButton = false;
    }

    get dialogName() {
        return "";
    }

    get formClass() {
        return "";
    }

    get dialogTitle() {
        return this.title?.toUpperCase ? this.tr(this.title) : (this.title || "");
    }

    set dialogTitle(value) {
        this.title = value;
    }

    componentWillUnmount() {
        this.clearCnts();
    }

    setOpenedState(opened) {
        this.setState({ opened }, opened ? this.setActive.bind(this) : this._onHide.bind(this));
    }

    setActive() {
        const tm = setTimeout(() => {
            clearTimeout(tm);
            this._helper.dom.addClass(this.domNode, "active");
            this.onShow();
        }, 10);
    }

    checkHide(e) {
        if (e.key === "Escape")
            this.hide();
    }

    clearCnts() {
        this._helper.disconnect(this.keyCnt);
    }

    show() {
        this.setOpenedState(true);

        this.clearCnts();
        this.keyCnt = this._helper.on(window, "keyup", this.checkHide.bind(this));
    }

    hide() {
        this.clearCnts();
        this.setOpenedState(false);
    }

    onShow() {

    }

    _onHide() {
        if (this.defaultState)
            this.setState({ ...this.defaultState });

        this.onHide();
    }

    onHide() {

    }

    save() {

    }

    insertRowText(rowText) {
        return (
            <div className="rowText text p2">
                {this.tr(rowText)}
            </div>
        );
    }

    insertLine() {
        return (
            <div className="line" />
        );
    }

    insertParagraf(rowText) {
        return (
            <div className="paragraf text p1SemiBold">
                {this.tr(rowText)}
            </div>
        );
    }

    insertRowInfo(title, value) {
        return (
            <div className="rowInfo text p2 flex gap16">
                <div className="rowInfoTitle">{this.tr(title)}</div>
                <div className={`rowInfoValue`}>
                    {this.tr(value)}
                </div>
            </div>
        );
    }

    renderContent() {
        return <></>;
    }

    renderButtons() {
        return (
            <div className="buttons flex end gap16">
                {!this.hideBackButton && (
                    <Button
                        label={this.dialogCancelLabel || "main.cancel"}
                        size="small"
                        type="transparent"
                        onClick={this.hide.bind(this)}
                    />
                )}
                <Button
                    label={this.dialogSaveLabel || "main.save"}
                    size="small"
                    onClick={this.save.bind(this)}
                    disabled={this.state.disableSave}
                />
            </div>
        );
    }

    renderForm() {
        return (
            <div className={`form flex col transit06 gap16 rad8 ${this.formClass}`}>
                <div className="flex centerV">
                    <div className="title flex1 text blockTitle">{this.dialogTitle}</div>
                    <CloseIcon className="close hand" onClick={this.hide.bind(this)} />
                </div>
                <div className="flex1 scrolling">
                    {this.renderContent()}
                    {this.renderButtons()}
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.opened)
            return <></>;

        return (
            <div
                className={`dialogItem ${this.dialogName} pos fixed sideAll flex centerAll transit025`}
                ref={el => this.domNode = el}
            >
                {this.renderForm()}
            </div>
        );
    }
}
